export interface ShouldFilterItemOptions<T> {
    inputValue: string;
    item: T;
    itemToString: (item: T) => string;
}
export const shouldFilterItem = <T>({ inputValue, item, itemToString }: ShouldFilterItemOptions<T>) => {
    return itemToString(item).toLowerCase().includes(inputValue.toLowerCase());
};
